import { GlobalReducer } from '../app';
import { Reducer } from 'redux';
import { initialResponseState, IResponseState } from '../state';
import { FormReportAction, FormReportTypes, IFormReportAction } from './formReport.type';

export const FormReportReducer: Reducer<IResponseState, IFormReportAction> = (
	state = initialResponseState,
	action: FormReportAction,
) => GlobalReducer(state, action, FormReportTypes.GET_FORM.toString());
